import { render, staticRenderFns } from "./mGrowup.vue?vue&type=template&id=0a9b337a&scoped=true&"
import script from "./mGrowup.vue?vue&type=script&lang=js&"
export * from "./mGrowup.vue?vue&type=script&lang=js&"
import style0 from "./mGrowup.vue?vue&type=style&index=0&id=0a9b337a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b337a",
  null
  
)

export default component.exports